import { AlertTriangle } from 'lucide-react';
import { Modal } from '@/components/ui/Modal';
import { useOfflineSessionStore } from '@/services/offline/offlineSessionStore';

// Confirmation shown when the user signs out while unsynced offline changes
// exist (offline, or sync failures). Rendered by OfflineSessionManager;
// confirmLogout() resolves with the user's choice.
export default function OfflineLogoutConfirmDialog() {
  const logoutPrompt = useOfflineSessionStore((s) => s.logoutPrompt);

  if (!logoutPrompt) return null;

  const { count, resolve } = logoutPrompt;

  return (
    <Modal
      isOpen
      onClose={() => resolve(false)}
      title="Unsynced changes"
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <button
            onClick={() => resolve(false)}
            className="px-4 py-2 text-sm font-medium rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Stay signed in
          </button>
          <button
            onClick={() => resolve(true)}
            className="px-4 py-2 text-sm font-medium rounded-md bg-red-600 text-white hover:bg-red-700"
          >
            Discard and sign out
          </button>
        </div>
      }
    >
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
        <p className="text-sm text-gray-700">
          {count} change{count > 1 ? 's have' : ' has'} not synced to the server.
          Signing out will permanently discard {count > 1 ? 'them' : 'it'}.
          {' '}Stay signed in and reconnect to sync first.
        </p>
      </div>
    </Modal>
  );
}
